import ProductFunctionality from "./ProductFunctionality";

const Products = () => {
  return (
    <div>
      <ProductFunctionality />
    </div>
  );
};

export default Products;
